import {
  onStreetPublic,
  onStreetPublicColors as colors,
} from "iparque-components";

export default {
  ...onStreetPublic,
  colors: {
    ...colors,
    enforcer: "#F44738",
    street: "#24CECE",
    offStreet: "#BABABA",
    sensing: "#CB0178",
  },
  scroll: {
    trackColor: colors.light,
    thumbColor: colors.primary,
  },
};
